<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Transferência"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <app-dados-fundo
    #portfolio
    id="fundo"
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Transfer"
    [isTransferTicket]="true"
    (emitterSelectedFund)="fillReceiverData($event)"
    (emitterSelectedFundAccount)="fillFundAccountList($event)"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da conta a ser creditada</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2" [class.has-error]="hasError('operationTypeId')">
          <label>Tipo Operação</label>
          <div>
            <div
              class="form-check form-check-inline"
              *ngFor="let item of ListaTipoOperacao; index as i"
            >
              <input
                class="form-check-input"
                type="radio"
                id="TipoOperacao-{{ i }}-id"
                name="operationTypeId"
                [(ngModel)]="model.operationTypeId"
                [value]="item.id"
                required
              />

              <label class="form-check-label" for="TipoOperacao-{{ i }}-id">
                {{ item.name }}
              </label>
            </div>
          </div>
        </div>

        <div class="offset-6"></div>

        <div class="col-4">
          <label>Valor da Operação</label>
          <input
            type="text"
            class="form-control"
            name="operationValue"
            data-cy="operationValue"
            [(ngModel)]="model.operationValue"
            currencyMask
            maxlength="38"
            required
          />
        </div>
      </div>

      <app-dados-fundo
        #receiver
        id="operation"
        [canEdit]="canEdit()"
        [canValidate]="canValidate"
        [ticketType]="TicketTypeEnum.Transfer"
        [showHeader]="false"
        [documentIsDisabled]="true"
        [nameIsDisabled]="true"
        [isTransferTicket]="true"
      ></app-dados-fundo>
    </div>
  </div>

  <br />

  <app-annotation #annotation [annotation]="model.annotations"></app-annotation>

  <mat-expansion-panel *ngIf="showTransferStatus()" hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Dados da Transferência </mat-panel-title>
      <mat-panel-description> (Clique para expandir...) </mat-panel-description>
    </mat-expansion-panel-header>
    <div style="padding: 1rem">
      <app-transfer-status
        #transferstatus
        [ticketId]="model.id"
      ></app-transfer-status>
    </div>
  </mat-expansion-panel>

  <br />

  <div class="actions" *ngIf="canEdit()">
    <input
      type="button"
      value="Salvar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Encaminhar"
      class="btn btn-primary me-2"
      [disabled]="!canEdit()"
      appDebounceClick
      (debounceClick)="forward()"
      [debounceTime]="200"
    />
    <input
      type="button"
      value="Cancelar"
      class="btn btn-danger me-2"
      [disabled]="!canCancel()"
      appDebounceClick
      (debounceClick)="cancel()"
      [debounceTime]="200"
    />
  </div>

  <div class="actions" *ngIf="canChangeStatus()">
    <input
      type="button"
      value="Aprovar"
      class="btn btn-success me-2"
      appDebounceClick
      (debounceClick)="approve()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
    <input
      type="button"
      value="Reprovar"
      class="btn btn-danger me-2"
      appDebounceClick
      (debounceClick)="reject()"
      [debounceTime]="200"
      [disabled]="disableActionButtons()"
    />
  </div>

  <div class="actions" *ngIf="canDuplicate()">
    <input
      type="button"
      value="Duplicar"
      class="btn btn-primary me-2"
      [disabled]="!model.id"
      appDebounceClick
      (debounceClick)="duplicate()"
      [debounceTime]="200"
    />
  </div>
  <app-workflow-history
    [ticketId]="model.id"
    [refresh]="dataChanged"
  ></app-workflow-history>
</form>
